import { IFilterItem } from '@shared/shared/interfaces/filter.interface';

/**
 * Takes a query param string such as q=london&filters=has_member_benefit%3Dtrue%26cuisine%3D4&ds=true
 * and turns it into an object such as
 * {
 *   q: london,
 *   filters: has_member_benefit=true&cuisine=4,
 *   ds: 'true'
 * }
 * Useful to pass into angular router for navigation
 * @param url
 */
export function transformStringToParamsObject(url: string): any {
  return url ? Object.fromEntries(new URLSearchParams(url) as unknown as Iterable<readonly [PropertyKey, any]>) : {};
}

/**
 * Takes a filter string such as has_member_benefit%3Dtrue%26cuisine%3D4 and
 * transforms it into an array such as
 * [
 *  {
 *    name: has_member_benefit,
 *    value: 'true'
 *  },
 *  {
 *    name: cuisine,
 *    value: 4
 *  }
 * ]
 * Useful to transform it into a format needed to pass to the back end
 * @param filterString
 */
export function transformFilterStringToArray(filterString: string): Array<IFilterItem> {
  if (!filterString) {
    return [];
  }
  filterString = filterString.includes('esg') ? filterString.replace('esg-tag', 'tag') : filterString;
  filterString = filterString.replace(/\"|\[|]/g, '');

  const filterArray: { name: string; value: string }[] = [];
  const filterList = decodeURIComponent(filterString);
  const splitList = filterList.split('&');
  splitList.forEach((filter: string) => {
    const splitFilter = filter.split('=');

    if (splitFilter[0] !== 'location' && splitFilter[1]?.search(',') !== -1) {
      const splitValue = splitFilter[1]?.split(',');
      splitValue.forEach((value: string) => filterArray.push({ name: splitFilter[0], value: value }));
    } else {
      filterArray.push({ name: splitFilter[0], value: splitFilter[1] });
    }
  });
  return filterArray;
}

/**
 * Takes a params object such as
 * {
 *   has_member_benefit: true,
 *   cuisine: 4
 * }
 * and turns it back into a url friendly string such as has_member_benefit%3Dtrue%26cuisine%3D4
 * @param paramsObject
 */
export function transformObjectToUrlString(paramsObject: any): string {
  return paramsObject ? new URLSearchParams(paramsObject).toString() : '';
}

export function getTagIdsFromTagFilterString(tags: string) {
  return /\[*([0-9,]*)\]*/
    .exec(tags)?.[1]
    ?.split(',')
    ?.map((id: string) => +id);
}
